import PillBottleIcon from "@/shared/media/icons/policy/Pill-Bottle.svg";
import { ReactNode } from "react";

export interface PromoCardProps {
    cornerText: string;
    iconText: string;
    content: ReactNode;
    footerText?: ReactNode;
}

export default function PromoCard(props: PromoCardProps) {
    const { cornerText, iconText, content, footerText } = props;
    return (
        <div className="relative mx-auto flex max-w-[610px] gap-8 rounded-xl border border-stroke-success bg-background-success px-6 pb-6 pt-8 lg:rounded-3xl lg:px-8 lg:pb-8 lg:pt-11">
            <div className="absolute right-[-1px] top-[-1px] z-10 rounded-bl-xl rounded-tr-xl bg-background-success-secondary px-2 py-1 text-center text-xs font-normal text-content-primary-invert lg:rounded-bl-3xl lg:rounded-tr-3xl lg:px-6 lg:py-2 lg:text-xl">
                {cornerText}
            </div>
            <div className="flex flex-col gap-2">
                <div className="flex items-center gap-4">
                    <div className="shrink-0">
                        <PillBottleIcon className="w-[70px]" />
                    </div>{" "}
                    <p className="text-lg font-bold text-content-primary lg:text-2xl">{iconText}</p>
                </div>
                {content && <div className="font-medium text-content-primary">{content}</div>}
                {footerText && <div className="text-xs font-medium text-content-secondary">{footerText}</div>}
            </div>
        </div>
    );
}
